import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ProblemSolution from './components/ProblemSolution';
import CategorySection from './components/CategorySection';
import Comparison from './components/Comparison';
import HowItWorks from './components/HowItWorks';
import CTASection from './components/CTASection';
import FAQ from './components/FAQ';
import ArticleEntry from './components/ArticleEntry';

const siteUrl = import.meta.env.VITE_SITE_URL;

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'YOYBUY Spreadsheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
  description: 'Автоматизированная spreadsheet-система для покупок на Taobao, 1688 и Weidian с доставкой в Россию и СНГ.',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['Russian', 'English'],
  },
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const webSiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY Spreadsheet',
  url: siteUrl,
  inLanguage: 'ru',
  description: 'Самый простой способ покупать из Китая — умная spreadsheet-система для покупок на Taobao, 1688 и Weidian без переплат.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <ProblemSolution />
        <CategorySection />
        <Comparison />
        <HowItWorks />
        <CTASection />
        <FAQ />
        <ArticleEntry />
      </main>
      <Footer />
    </>
  );
}